// N19-3 — THE HOW-THIS-WORKS MOMENT. A few lines in her register at the top of signup: what she is
// about to get, and the one thing she has to get right. It collapses to a single line on "Got it"
// rather than vanishing, so a member who dismissed it too fast can open it again without a reload.
//
// THE COPY IS A PLACEHOLDER AWAITING THE OWNER'S WORD (N19-3). It lives in `src/strings.js`, in one
// place, in both languages, so replacing it is one edit.
//
// **IT LEFT App.tsx ON LAUNCH DAY, AND THE RATCHET IS WHAT BOUGHT THE MOVE.** L2.6 needed about
// thirty lines in App.tsx for her dismissible signup box, and roadmap 7's ceiling only ever goes
// down — so the item paid for them by moving this out, which is that ratchet doing what its own rule
// describes: *"a ceiling that only ever says no would have stopped the feature; this one bought two
// extractions with it."* CLAUDE.md named this component as one of the two still stuck in App.tsx
// because it holds a hook; R10-3's ruling is that a hook only blocks a component a gate CALLS, and
// out here nothing calls it — so the move costs no reach and gains a file a gate can load.
//
// It is the create-your-room box's own child, so it moved with the round that changed that box.
import { useState } from "react";
import { DEFAULT_LANGUAGE } from "../language.js";
import { t } from "../strings.js";

export function HowThisWorks({ language = DEFAULT_LANGUAGE }: { language?: string }) {
  const [open, setOpen] = useState(true);
  if (!open) {
    return (
      <button type="button" className="onboard-how__reopen" onClick={() => setOpen(true)}>
        {t(language, "signup.how.reopen")}
      </button>
    );
  }
  return (
    <div className="onboard-how" role="note">
      <p className="onboard-how__line">{t(language, "signup.how.line1")}</p>
      <p className="onboard-how__line">{t(language, "signup.how.line2")}</p>
      <p className="onboard-how__line">{t(language, "signup.how.line3")}</p>
      <button type="button" className="onboard-how__got" onClick={() => setOpen(false)}>{t(language, "signup.how.got")}</button>
    </div>
  );
}
